// languages/spanish.js
export const spanish = {
  name: "Española",
  interface: {
    welcome: "Bienvenidos",
    chooseLanguage: "Elige el idioma",
    continue: "Continuar",
    backToMap: "Volver al mapa",
    achievement: "Logros",
    viewInAR: "Ver en AR",
    menu: {
      menu: "Menú",
      home: "Inicio",
      language: "Idioma",
      achievement: "Logros",
      unsuiExperience: "Experiencia Unsui",
      feedback: "Comentarios",
    },
    buyScreen: {
      clickToBuy: "¡Haz clic para comprar una experiencia",
      templeExperience: "especial en el templo!",
      description1: "Escucha historias fascinantes sobre ",
      description2: "el templo con una guía de audio",
      description3: "y disfruta de un AR mágico.",
      buy: "Comprar",
    },
    gift: {
      congratulations: "¡Felicidades!",
      yourGift: "Tu regalo",
      giftTitle: "The Supreme Truth",
      giftText: "Check out this amazing gift!",
    },
  },
};
